import React, { Component } from "react";
import { config } from "../../config/general.config";
import { Form, Select } from "antd";

const { Option } = Select;

class SelectValveConfig extends Component {
  initState = {
    dataOption: config.enum_valve_config,
  };
  state = { ...this.initState };

  componentDidMount = async () => {
    try {
    } catch (error) {
      this.setState({
        dataOption: [],
      });
    }
  };

  render() {
    return (
      <Form.Item label="Engine Valve Config" name="engine_valve_config" className="col-lg-12 my-1 py-1" labelCol={this.props.labelCol} wrapperCol={this.props.wrapperCol}>
        <Select style={{ fontSize: "85%", minWidth: "200px" }} placeholder="Select Engine Valve Config" onChange={this.props.onChangeValue} mode={this.props.mode}>
          {this.state.dataOption.map((d, i) => {
            return (
              <Option key={d} value={d}>
                {d}
              </Option>
            );
          })}
        </Select>
      </Form.Item>
    );
  }
}

export default SelectValveConfig;
